export const answerDetailLang = {
    answerDetail: 'جزییات پاسخنامه',
    statuses: {
        complete: 'تکمیل شده',
        incomplete: 'تکمیل نشده',
    },
    complete: 'تکمیل',
    edit: 'ویرایش',
    noItems: 'پاسخی برای این سوال درج نشده است',
};
